"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.regexp.split");

























































































































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {var _this = this;var validExample = function validExample(rule, value, callback) {var regx = /^\w*[0-9]+-[0-9]+$/;if (value != null || value !== '') {var result = regx.test(value);if (result < 1) {callback(new Error('请输入正确格式的SN区间'));} else {var strs = value.split('-');var first = strs[0];var second = strs[1];var changeNum = second.length;strs = first.substr(0, first.length - second.length);first = first.substr(first.length - second.length, first.length);var isNum = parseInt(first);if (isNaN(isNum)) {callback(new Error('请输入正确格式的SN区间'));} else {_this.snChangeFun(strs, changeNum, first, second);callback();}}}callback();};return { tableData: [], // 列表数据
      droplist: [], droplist2: [], imageSrcList: [], searchData: { incomingNo: '', sn: '', auditStatus: '', deviceTypeCode: '', endTime: '', startTime: '', regionalId: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, regionList: [], //服务区域列表
      showDialog: false, deviceCode: '', newadd: false, title: '新增', addData: { regionalId: '', id: '', startSn: '', supportSecretKey: '', quantity: '', deviceTypeCode: '', deviceTypeId: '', desc: '', excelFile: '', name: '', remark: '', file: '' }, defaultData: { regionalId: '', id: '', startSn: '', supportSecretKey: '', quantity: '', deviceTypeCode: '', deviceTypeId: '', desc: '', excelFile: '', name: '', remark: '', file: '' }, // 表格列
      tableColumns: [{ prop: 'incomingNo', label: '入库单号', isShow: true }, { prop: 'equipmentQuantity', label: '设备数量', isShow: true }, { prop: 'regionalName', label: '服务区域', isShow: true }, { prop: 'deviceTypeCode', label: '设备型号', isShow: true, formatter: _formatter.deviceTypeFormatter }, { prop: 'auditStatus', label: '审核状态', formatter: _formatter.reviewFormatter, isShow: true }, { prop: 'auditTime', label: '审核时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'remark', label: '备注', isShow: true }], rules: { regionalId: [{ required: true, message: '请选择服务区域', trigger: 'change' }], startSn: [{ required: true, message: '请输入开始SN码', trigger: 'change' }], quantity: [{ required: true, message: '请输入生成数量(台)', trigger: 'change' }], deviceTypeCode: [{ required: true, message: '请选择设备类别', trigger: 'change' }], deviceTypeId: [{ required: true, message: '请选择设备型号', trigger: 'change' }] }, showImport: false };}, mounted: function mounted() {var self = this;self.init();self.getdrop();self.getdrop2();self.fetchRegionList();}, methods: { /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * 获取区域列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              */fetchRegionList: function fetchRegionList() {var _this2 = this;this.getData('/api/faServicesRegional/getAll', { page: 1, rows: 9999999 }, function (res) {_this2.regionList = res.list;});}, init: function init() {var self = this;self.getData('/api/faInstorage/', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.incomingNo = '';this.searchData.sn = '';this.searchData.auditStatus = '';this.searchData.endTime = '';this.searchData.startTime = '';this.searchData.regionalId = '';this.searchData.deviceTypeCode = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;console.log('searchData.startTime', this.searchData.startTime);var start = new Date(this.searchData.startTime);var deliverTimeStart = start.getTime();var end = new Date(this.searchData.endTime);var deliverTimeEnd = end.getTime();if (deliverTimeStart > deliverTimeEnd) {this.$message({ message: '请选择结束时间要大于开始时间', type: 'error' });this.searchData.endTime = '';return false;}if (this.searchData.endTime) {var endTime = this.searchData.endTime;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.endTime = endTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faInstorage/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});}).catch(function () {});}, exportQRMenu: function exportQRMenu(item) {var url = '/api/faInstorageDetail/instorage/' + item.id + '/downloadQrCode';var self = this;if (item.auditStatus === 1) {var link = document.createElement('a');link.setAttribute('href', url);link.setAttribute('target', '_blank');
        link.click();
      } else if (item.auditStatus === 0) {
        self.$message({
          message: '该入库单号未审核的不能导出，请先审核再导出！',
          type: 'error' });

        return false;
      }
    },
    reviewMenu: function reviewMenu(item) {
      var self = this;
      self.$confirm('确定审核该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var url = '/api/faInstorage/' + item.id + '/audit';
        self.postData(url, {}, function (res) {
          self.$message({
            message: '审核成功!',
            type: 'success' });

          // self.searchData.page = 1
          self.init();
        });
      }).catch(function () {});
    },
    unReviewMenu: function unReviewMenu(item) {
      var self = this;
      self.$confirm('确定反审核该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var url = '/api/faInstorage/' + item.id + '/reverseAudit';
        self.postData(url, {}, function (res) {
          self.$message({
            message: '反审核成功!',
            type: 'success' });

          // self.searchData.page = 1
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var params = {
            remark: self.addData.remark,
            regionalId: self.addData.regionalId,
            deviceTypeId: self.addData.deviceTypeId };


          self.postData('/api/faInstorage', params, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        }
      });
    },
    onFastSubmit: function onFastSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faInstorageDetail/quickImport', self.addData,
          function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });

        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        remarks: item.remarks,
        bluetooth: item.bluetooth,
        name: item.name,
        command: item.command,
        imageFile: item.imageFile,
        image: item.image,
        description: item.description,
        intensity: item.intensity,
        type: item.type,
        typeCode: item.typeCode };

      if (item.type === '1') {
        self.addData.type = '固定';
      } else if (item.type === '2') {
        self.addData.type = '组合';
      }
      self.newadd = true;
    },
    onCencal: function onCencal() {
      // this.$refs.addForm && this.$refs.addForm.resetFields()
      if (this.addData.excelFile) {
        this.addData.excelFile = [];
        var dr = document.getElementById('daoru');
        if (dr) {
          dr.outerHTML = dr.outerHTML;
        }
      }
      this.newadd = false;
    },
    onImportCencal: function onImportCencal() {
      this.addData = Object.assign({}, this.defaultData);
      this.showImport = false;
    },
    closeDiglog: function closeDiglog() {
      // this.$refs.addForm && this.$refs.addForm.resetFields()
      // Object.keys(this.addData).forEach(e => {
      //   this.$set(this.addData, e, '')
      // })
      this.addData = Object.assign({}, this.defaultData);
      // var dr = document.getElementById('daoru')
      // if(dr){
      //   dr.outerHTML = dr.outerHTML
      // }
      this.newadd = false;
    },
    closeImportDiglog: function closeImportDiglog() {
      this.addData = Object.assign({}, this.defaultData);
      // var dr = document.getElementById('daoru')
      // if(dr){
      //   dr.outerHTML = dr.outerHTML
      // }
      this.showImport = false;
    },
    getFile: function getFile(event) {
      console.log('getFile=========>', event);
      this.addData.excelFile = event.target.files[0];
      console.log('excelFile', this.addData.excelFile);
    },
    importExcel: function importExcel(item) {
      this.addData.id = item.id;
      this.showImport = true;
      this.addData = JSON.parse(JSON.stringify(item));
    },
    onImport: function onImport(event) {var _this3 = this;
      var self = this;
      self.$refs.importForm.validate(function (valid) {
        if (valid) {
          var File = new FormData();
          File.append('excelFile', self.addData.excelFile);
          self.postData('/api/faInstorageDetail/import/' + _this3.addData.id, File, function (res) {
            self.$message({
              message: '导入成功!',
              type: 'success' });

            self.onImportCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    fastAddFun: function fastAddFun() {// 快速生成
      this.title = '快速生成';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.getdrop();
      this.newadd = true;
    },
    getdrop: function getdrop(query) {
      console.log('query=======>', query);
      var self = this;
      self.getData('/api/faDeviceType', {
        rows: 30,
        name: query },
      function (res) {
        // self.droplist = res.list
        if (res.list.length > 0) {
          self.droplist = res.list;
        } else if (res.list.length == 0) {
          self.$message({
            message: '没有该产品类型，请重新搜索!',
            type: 'warning' });

          self.addData.name = '';
        }
      });
    },
    getdrop2: function getdrop2() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist2 = res;
      });
    },
    snChangeFun: function snChangeFun(str, changeNum, first, second) {
      this.addData.prefix = str;
      this.addData.startNum = first;
      this.addData.endNum = second;
    },
    get: function get(event) {
      var self = this;
      if (event.keyCode == 38 || event.keyCode == 40) return;
      self.getdrop();
    } } };exports.default = _default;